/* eslint-disable prettier/prettier */
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { initialize } from 'redux-form';
import types from './types';

const URL_GROUPING = `${BASE_API}/groupings`;
const URL_GROUPINGS = `${BASE_API}/groupings-list-table`;
const URL_GROUPINGS_STATION = `${BASE_API}/groupings-station`;
const URL_GROUPINGS_PARTICIPANTS = `${BASE_API}/groupings-participants-list`;

export const getGroupingsStationId = (station_id) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: true });
    axios
      .get(`${URL_GROUPINGS}/?where[active]=1&where[station_id]=${station_id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const filteredData = (response.data || []).filter(
          (item) => item.station_id === station_id
        );
        dispatch([
          {
            type: types.LIST_FETCHED,
            payload: filteredData,
          },
        ]);
      })
      .catch((err) => {
        dispatch({ type: types.LIST_LOAD, payload: false });
        console.log(err);
      });
  };
};

// Buscar agrupamentos de múltiplas stations
export const getGroupingsMultipleStations = (stationIds, stationsMap = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: true });
    try {
      const ids = Array.isArray(stationIds) ? stationIds : [stationIds];
      
      const responses = await Promise.all(
        ids.map((stationId) =>
          axios
            .get(`${URL_GROUPINGS}/?where[active]=1&where[station_id]=${stationId}`, {
              headers: {
                Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
              },
            })
            .catch(() => ({ data: [] }))
        )
      );
      
      // Combinar todos os agrupamentos, adicionando o nome da station
      const allGroupings = [];
      const groupingIds = new Set();
      
      responses.forEach((response, index) => {
        const stationId = ids[index];
        const stationName = stationsMap[stationId] || '';
        const data = response.data || [];
        (Array.isArray(data) ? data : []).forEach((grouping) => {
          if (grouping && grouping.id && !groupingIds.has(grouping.id)) {
            groupingIds.add(grouping.id);
            allGroupings.push({
              ...grouping,
              stationId: stationId,
              stationName: stationName,
            });
          }
        });
      });
      
      dispatch({
        type: types.LIST_FETCHED,
        payload: allGroupings,
      });
    } catch (err) {
      dispatch({ type: types.LIST_LOAD, payload: false });
      console.error('Erro ao buscar agrupamentos:', err);
    }
  };
};

export const getGroupingsParticipantsStationId = (station_id) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_PARTICIPANTS_FETCHED, payload: true });
    axios
      .get(
        `${URL_GROUPINGS_PARTICIPANTS}/?where[station_id]=${station_id}&where[active]=1&where[type_id]=2`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        dispatch([
          {
            type: types.LIST_PARTICIPANTS_FETCHED,
            payload: response.data,
          },
        ]);
      })
      .catch((err) => {
        dispatch({ type: types.LIST_LOAD, payload: false });
        console.log(err);
      });
  };
};

export const getGroupingById = (id) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: true });
    axios
      .get(`${URL_GROUPING}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const responseFormatted = {
          ...response.data,
          participants: response.data?.grouping_user
            ?.filter((it) => it.user) // Garante que it.user não seja nulo
            .map((it) => ({
              id: it.user.id,
              title: it.user.name,
            })),
          actions: response.data?.action_grouping
            ?.filter((it) => it.action) // Garante que it.action não seja nulo
            .map((it) => ({
              id: it.action.id,
              title: it.action.name,
            })),
        };
        // console.log(response.data, responseFormatted);
        dispatch([
          {
            type: types.ITEM_DETAIL,
            payload: responseFormatted,
          },
          initializeForm(responseFormatted),
        ]);
      })
      .catch((err) => {
        dispatch({ type: types.LIST_LOAD, payload: false });
        console.log(err);
      });
  };
};

const initializeForm = (values) => {
  return initialize('groupingsForm', values);
};

export const deleteGroupingById = (groupingcode_id, station_id, setVisible) => {
  return (dispatch) => {
    dispatch({ type: types.BUTTON_LOAD, payload: true });
    axios
      .delete(`${URL_GROUPING}/${groupingcode_id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([{ type: types.BUTTON_LOAD, payload: false }, getGroupingsStationId(station_id)]);
        setVisible({ visible: false });
      })
      .catch((err) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });
        console.log(err);
      });
  };
};

export const createGrouping = (values, station_id, router) => {
  return (dispatch) => {
    dispatch({ type: types.BUTTON_LOAD, payload: true });
    axios
      .post(`${URL_GROUPINGS_STATION}/${station_id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });
        router.push('/owner/groupings');
      })
      .catch((err) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });
        console.log(err);
      });
  };
};

export const editGrouping = (values, groupingcode_id, router) => {
  return (dispatch) => {
    dispatch({ type: types.BUTTON_LOAD, payload: true });
    axios
      .put(`${URL_GROUPING}/${groupingcode_id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });
        router.push('/owner/groupings');
      })
      .catch((err) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });
        console.log(err);
      });
  };
};
